





import {Component, Vue, Watch} from 'vue-property-decorator'
import kepler from "../../../lib/kepler_sdk/kepler";

@Component({
  components: {},
})
export default class Assets extends Vue {

  public openRoute(name: string) {
    this.$router.push({name})
  }

  public items = []
  public options = {
    page: 1,
    itemsPerPage: 20
  }

  public loading = true

  public totalItems = null
  public totalPages = null

  public mounted() {
    this.dataLoad()
  }

  @Watch('options', {
    deep: true
  })
  private dataLoad() {
    this.loading = true
    kepler.get('vehicle_categories', this.options)!.then((d) => {
      this.totalItems = d.data.items_count
      this.totalPages = d.data.page_count
      this.items = d.data
      this.loading = false
    })
  }
}
